"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUnshieldBaseTokenProof = exports.generateUnshieldProof = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const tx_generator_1 = require("./tx-generator");
const wallets_1 = require("../railgun/wallets/wallets");
const proof_cache_1 = require("./proof-cache");
const providers_1 = require("../railgun/core/providers");
const engine_1 = require("@railgun-community/engine");
const blocked_address_1 = require("../../utils/blocked-address");
const tx_cross_contract_calls_1 = require("./tx-cross-contract-calls");
const error_1 = require("../../utils/error");
const generateUnshieldProof = async (networkName, railgunWalletID, encryptionKey, erc20AmountRecipients, nftAmountRecipients, relayerFeeERC20AmountRecipient, sendWithPublicWallet, overallBatchMinGasPrice, progressCallback) => {
    try {
        (0, proof_cache_1.setCachedProvedTransaction)(undefined);
        const transactions = await (0, tx_generator_1.generateProofTransactions)(shared_models_1.ProofType.Unshield, networkName, railgunWalletID, encryptionKey, false, // showSenderAddressToRecipient
        undefined, // memoText
        erc20AmountRecipients, nftAmountRecipients, relayerFeeERC20AmountRecipient, sendWithPublicWallet, undefined, // relayAdaptID
        false, // useDummyProof
        overallBatchMinGasPrice, progressCallback);
        const transaction = await (0, tx_generator_1.generateTransact)(transactions, networkName);
        const nullifiers = (0, tx_generator_1.nullifiersForTransactions)(transactions);
        (0, proof_cache_1.setCachedProvedTransaction)({
            proofType: shared_models_1.ProofType.Unshield,
            railgunWalletID,
            showSenderAddressToRecipient: false,
            memoText: undefined,
            erc20AmountRecipients,
            nftAmountRecipients,
            relayAdaptUnshieldERC20Amounts: undefined,
            relayAdaptUnshieldNFTAmounts: undefined,
            relayAdaptShieldERC20Recipients: undefined,
            relayAdaptShieldNFTRecipients: undefined,
            crossContractCalls: undefined,
            relayerFeeERC20AmountRecipient,
            transaction,
            sendWithPublicWallet,
            overallBatchMinGasPrice,
            nullifiers,
        });
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.generateUnshieldProof.name, err);
    }
};
exports.generateUnshieldProof = generateUnshieldProof;
const generateUnshieldBaseTokenProof = async (networkName, publicWalletAddress, railgunWalletID, encryptionKey, wrappedERC20Amount, relayerFeeERC20AmountRecipient, sendWithPublicWallet, overallBatchMinGasPrice, progressCallback) => {
    try {
        (0, blocked_address_1.assertNotBlockedAddress)(publicWalletAddress);
        (0, wallets_1.assertValidEthAddress)(publicWalletAddress);
        (0, proof_cache_1.setCachedProvedTransaction)(undefined);
        const erc20AmountRecipients = [
            {
                ...wrappedERC20Amount,
                recipientAddress: publicWalletAddress,
            },
        ];
        const relayAdaptUnshieldERC20Amounts = [
            wrappedERC20Amount,
        ];
        const relayAdaptUnshieldERC20AmountRecipients = (0, tx_cross_contract_calls_1.createRelayAdaptUnshieldERC20AmountRecipients)(networkName, [
            wrappedERC20Amount,
        ]);
        // Empty NFT recipients.
        const nftAmountRecipients = [];
        const relayAdaptUnshieldNFTAmountRecipients = [];
        const relayAdaptContract = (0, providers_1.getRelayAdaptContractForNetwork)(networkName);
        // Generate dummy txs for relay adapt params.
        const dummyTxs = await (0, tx_generator_1.generateDummyProofTransactions)(shared_models_1.ProofType.UnshieldBaseToken, networkName, railgunWalletID, encryptionKey, false, // showSenderAddressToRecipient
        undefined, // memoText
        relayAdaptUnshieldERC20AmountRecipients, relayAdaptUnshieldNFTAmountRecipients, relayerFeeERC20AmountRecipient, sendWithPublicWallet, overallBatchMinGasPrice);
        const relayAdaptParamsRandom = (0, engine_1.randomHex)(31);
        const relayAdaptParams = await relayAdaptContract.getRelayAdaptParamsUnshieldBaseToken(dummyTxs, publicWalletAddress, relayAdaptParamsRandom);
        const relayAdaptID = {
            contract: relayAdaptContract.address,
            parameters: relayAdaptParams,
        };
        const showSenderAddressToRecipient = false;
        const memoText = undefined;
        // Generate final txs with relay adapt ID.
        const transactions = await (0, tx_generator_1.generateProofTransactions)(shared_models_1.ProofType.UnshieldBaseToken, networkName, railgunWalletID, encryptionKey, showSenderAddressToRecipient, memoText, relayAdaptUnshieldERC20AmountRecipients, relayAdaptUnshieldNFTAmountRecipients, relayerFeeERC20AmountRecipient, sendWithPublicWallet, relayAdaptID, false, // useDummyProof
        overallBatchMinGasPrice, progressCallback);
        const transaction = await (0, tx_generator_1.generateUnshieldBaseToken)(transactions, networkName, publicWalletAddress, relayAdaptParamsRandom, false);
        const nullifiers = (0, tx_generator_1.nullifiersForTransactions)(transactions);
        (0, proof_cache_1.setCachedProvedTransaction)({
            proofType: shared_models_1.ProofType.UnshieldBaseToken,
            railgunWalletID,
            showSenderAddressToRecipient,
            memoText,
            erc20AmountRecipients,
            nftAmountRecipients,
            relayAdaptUnshieldERC20Amounts,
            relayAdaptUnshieldNFTAmounts: undefined,
            relayAdaptShieldERC20Recipients: undefined,
            relayAdaptShieldNFTRecipients: undefined,
            crossContractCalls: undefined,
            relayerFeeERC20AmountRecipient,
            sendWithPublicWallet,
            transaction,
            overallBatchMinGasPrice,
            nullifiers,
        });
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.generateUnshieldBaseTokenProof.name, err);
    }
};
exports.generateUnshieldBaseTokenProof = generateUnshieldBaseTokenProof;
